import { parsePhoneNumber } from 'libphonenumber-js';

export const paymentCompanySupportParsePhoneNumber = (phoneNumber: string) => {
  try {
    const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'BR');

    if (!parsedPhoneNumber.isValid()) {
      return null;
    }

    return parsedPhoneNumber;
  } catch (_err) {
    return null;
  }
};
